import PptxGenJS from "pptxgenjs";
import { TemplateData } from "../index";
import { renderScoresChartSlide } from "./_scoresChartHelpers";
import { HPI_CONFIG } from "./_scoresChartConfigs";

export const hoganPersonalityInventorySlide = (
  pres: PptxGenJS,
  data: TemplateData
) => {
  const slide = pres.addSlide({ masterName: "SPLIT_RIGHT_MASTER" });
  renderScoresChartSlide(pres, slide, data, data.candidateName, HPI_CONFIG);
};
